class BrowserUID {
  constructor() {
  }

  load() {
    this.browserType();
    const sources = {
      fonts: this.getFonts.bind(this),
      domBlockers: this.getDomBlockers.bind(this),
      fontPreferences: this.getFontPreferences.bind(this),
      audio: this.getAudioFingerprint.bind(this),
      screenFrame: this.getScreenFrame.bind(this),
      canvas: this.getUnstableCanvasFingerprint.bind(this),
      osCpu: this.getOsCpu.bind(this),
      languages: this.getLanguages.bind(this),
      colorDepth: this.getColorDepth.bind(this),
      deviceMemory: this.getDeviceMemory.bind(this),
      screenResolution: this.getScreenResolution.bind(this),
      hardwareConcurrency: this.getHardwareConcurrency.bind(this),
      timezone: this.getTimezone.bind(this),
      sessionStorage: this.areSessionStorage.bind(this),
      localStorage: this.areLocalStorage.bind(this),
      indexedDB: this.areIndexedDB.bind(this),
      openDatabase: this.areOpenDatabase.bind(this),
      cpuClass: this.getCpuClass.bind(this),
      platform: this.getPlatform.bind(this),
      plugins: this.getPlugins.bind(this),
      touchSupport: this.getTouchSupport.bind(this),
      vendor: this.getVendor.bind(this),
      vendorFlavors: this.getVendorFlavors.bind(this),
      cookiesEnabled: this.areCookiesEnabled.bind(this),
      colorGamut: this.getColorGamut.bind(this),
      invertedColors: this.areColorsInverted.bind(this),
      forcedColors: this.areColorsForced.bind(this),
      monochrome: this.getMonochromeDepth.bind(this),
      contrast: this.getContrastPreference.bind(this),
      reducedMotion: this.isMotionReduced.bind(this),
      reducedTransparency: this.isTransparencyReduced.bind(this),
      hdr: this.isHDR.bind(this),
      math: this.getMathFingerprint.bind(this),
      pdfViewerEnabled: this.isPdfViewerEnabled.bind(this),
      architecture: this.getArchitecture.bind(this),
      applePay: this.getApplePayState.bind(this),
      privateClickMeasurement: this.getPrivateClickMeasurement.bind(this),
      audioBaseLatency: this.getAudioContextBaseLatency.bind(this),
      dateTimeLocale: this.getDateTimeLocale.bind(this),
      webGlBasics: this.getWebGlBasics.bind(this),
      webGlExtensions: this.getWebGlExtensions.bind(this),
    }
    return this.loadSources(sources, {})
  }

  async get() {
    const b = this.load()
    const components = await b()
    let result = ''
    for (const componentKey of Object.keys(components).sort()) {
      const component = components[componentKey]
      const value = 'error' in component ? 'error' : JSON.stringify(component.value)
      result += `${result ? '|' : ''}${componentKey.replace(/([:|\\])/g, '\\$1')}:${value}`
    }
    return this.x64hash128(result)

  }

  x64hash128( input, seed ) {
    const F1 = [0xff51afd7, 0xed558ccd]
    const F2 = [0xc4ceb9fe, 0x1a85ec53]
    const C1 = [0x87c37b91, 0x114253d5]
    const C2 = [0x4cf5ad43, 0x2745937f]
    const M = [0, 5]
    const N1 = [0, 0x52dce729]
    const N2 = [0, 0x38495ab5]

    const getUTF8Bytes = ( input ) => {
      const result = new Uint8Array(input.length)
      for (let i = 0; i < input.length; i++) {
        const charCode = input.charCodeAt(i)
        if (charCode > 127) {
          return new TextEncoder().encode(input)
        }
        result[i] = charCode
      }
      return result
    }
    const x64Add = ( m, n ) => {
      const m0 = m[0] >>> 16,
        m1 = m[0] & 0xffff,
        m2 = m[1] >>> 16,
        m3 = m[1] & 0xffff

      const n0 = n[0] >>> 16,
        n1 = n[0] & 0xffff,
        n2 = n[1] >>> 16,
        n3 = n[1] & 0xffff

      let o0 = 0,
        o1 = 0,
        o2 = 0,
        o3 = 0
      o3 += m3 + n3
      o2 += o3 >>> 16
      o3 &= 0xffff
      o2 += m2 + n2
      o1 += o2 >>> 16
      o2 &= 0xffff
      o1 += m1 + n1
      o0 += o1 >>> 16
      o1 &= 0xffff
      o0 += m0 + n0
      o0 &= 0xffff

      m[0] = (o0 << 16) | o1
      m[1] = (o2 << 16) | o3
    }
    const x64Multiply = ( m, n ) => {
      const m0 = m[0] >>> 16,
        m1 = m[0] & 0xffff,
        m2 = m[1] >>> 16,
        m3 = m[1] & 0xffff

      const n0 = n[0] >>> 16,
        n1 = n[0] & 0xffff,
        n2 = n[1] >>> 16,
        n3 = n[1] & 0xffff
      let o0 = 0,
        o1 = 0,
        o2 = 0,
        o3 = 0

      o3 += m3 * n3
      o2 += o3 >>> 16
      o3 &= 0xffff
      o2 += m2 * n3
      o1 += o2 >>> 16
      o2 &= 0xffff
      o2 += m3 * n2
      o1 += o2 >>> 16
      o2 &= 0xffff
      o1 += m1 * n3
      o0 += o1 >>> 16
      o1 &= 0xffff
      o1 += m2 * n2
      o0 += o1 >>> 16
      o1 &= 0xffff
      o1 += m3 * n1
      o0 += o1 >>> 16
      o1 &= 0xffff
      o0 += m0 * n3 + m1 * n2 + m2 * n1 + m3 * n0
      o0 &= 0xffff

      m[0] = (o0 << 16) | o1
      m[1] = (o2 << 16) | o3
    }
    const x64Rotl = ( m, bits ) => {
      const m0 = m[0]
      bits %= 64
      if (bits === 32) {
        m[0] = m[1]
        m[1] = m0
      } else if (bits < 32) {
        m[0] = (m0 << bits) | (m[1] >>> (32 - bits))
        m[1] = (m[1] << bits) | (m0 >>> (32 - bits))
      } else {
        bits -= 32
        m[0] = (m[1] << bits) | (m0 >>> (32 - bits))
        m[1] = (m0 << bits) | (m[1] >>> (32 - bits))
      }
    }
    const x64LeftShift = ( m, bits ) => {
      bits %= 64
      if (bits === 0) {
        return
      } else if (bits < 32) {
        m[0] = m[1] >>> (32 - bits)
        m[1] = m[1] << bits
      } else {
        m[0] = m[1] << (bits - 32)
        m[1] = 0
      }
    }
    const x64Xor = ( m, n ) => {
      m[0] ^= n[0]
      m[1] ^= n[1]
    }
    const x64Fmix = ( h ) => {
      const shifted = [0, h[0] >>> 1]
      x64Xor(h, shifted)
      x64Multiply(h, F1)
      shifted[1] = h[0] >>> 1
      x64Xor(h, shifted)
      x64Multiply(h, F2)
      shifted[1] = h[0] >>> 1
      x64Xor(h, shifted)
    }

    const key = getUTF8Bytes(input)
    seed = seed || 0
    const length = [0, key.length]
    const remainder = length[1] % 16
    const bytes = length[1] - remainder
    const h1 = [0, seed]
    const h2 = [0, seed]
    const k1 = [0, 0]
    const k2 = [0, 0]

    let i
    for (i = 0; i < bytes; i = i + 16) {
      k1[0] = key[i + 4] | (key[i + 5] << 8) | (key[i + 6] << 16) | (key[i + 7] << 24)
      k1[1] = key[i] | (key[i + 1] << 8) | (key[i + 2] << 16) | (key[i + 3] << 24)
      k2[0] = key[i + 12] | (key[i + 13] << 8) | (key[i + 14] << 16) | (key[i + 15] << 24)
      k2[1] = key[i + 8] | (key[i + 9] << 8) | (key[i + 10] << 16) | (key[i + 11] << 24)

      x64Multiply(k1, C1)
      x64Rotl(k1, 31)
      x64Multiply(k1, C2)
      x64Xor(h1, k1)
      x64Rotl(h1, 27)
      x64Add(h1, h2)
      x64Multiply(h1, M)
      x64Add(h1, N1)
      x64Multiply(k2, C2)
      x64Rotl(k2, 33)
      x64Multiply(k2, C1)
      x64Xor(h2, k2)
      x64Rotl(h2, 31)
      x64Add(h2, h1)
      x64Multiply(h2, M)
      x64Add(h2, N2)
    }
    k1[0] = 0
    k1[1] = 0
    k2[0] = 0
    k2[1] = 0
    const val = [0, 0]
    switch (remainder) {
      case 15:
        val[1] = key[i + 14]
        x64LeftShift(val, 48)
        x64Xor(k2, val)
      // fallthrough
      case 14:
        val[1] = key[i + 13]
        x64LeftShift(val, 40)
        x64Xor(k2, val)
      // fallthrough
      case 13:
        val[1] = key[i + 12]
        x64LeftShift(val, 32)
        x64Xor(k2, val)
      // fallthrough
      case 12:
        val[1] = key[i + 11]
        x64LeftShift(val, 24)
        x64Xor(k2, val)
      // fallthrough
      case 11:
        val[1] = key[i + 10]
        x64LeftShift(val, 16)
        x64Xor(k2, val)
      // fallthrough
      case 10:
        val[1] = key[i + 9]
        x64LeftShift(val, 8)
        x64Xor(k2, val)
      // fallthrough
      case 9:
        val[1] = key[i + 8]

        x64Xor(k2, val)
        x64Multiply(k2, C2)
        x64Rotl(k2, 33)
        x64Multiply(k2, C1)
        x64Xor(h2, k2)
      // fallthrough
      case 8:
        val[1] = key[i + 7]
        x64LeftShift(val, 56)
        x64Xor(k1, val)
      // fallthrough
      case 7:
        val[1] = key[i + 6]
        x64LeftShift(val, 48)
        x64Xor(k1, val)
      // fallthrough
      case 6:
        val[1] = key[i + 5]
        x64LeftShift(val, 40)
        x64Xor(k1, val)
      // fallthrough
      case 5:
        val[1] = key[i + 4]
        x64LeftShift(val, 32)
        x64Xor(k1, val)
      // fallthrough
      case 4:
        val[1] = key[i + 3]
        x64LeftShift(val, 24)
        x64Xor(k1, val)
      // fallthrough
      case 3:
        val[1] = key[i + 2]
        x64LeftShift(val, 16)
        x64Xor(k1, val)
      // fallthrough
      case 2:
        val[1] = key[i + 1]
        x64LeftShift(val, 8)
        x64Xor(k1, val)
      // fallthrough
      case 1:
        val[1] = key[i]

        x64Xor(k1, val)
        x64Multiply(k1, C1)
        x64Rotl(k1, 31)
        x64Multiply(k1, C2)
        x64Xor(h1, k1)
      // fallthrough
    }
    x64Xor(h1, length)
    x64Xor(h2, length)
    x64Add(h1, h2)
    x64Add(h2, h1)
    x64Fmix(h1)
    x64Fmix(h2)
    x64Add(h1, h2)
    x64Add(h2, h1)
    return (
      ('00000000' + (h1[0] >>> 0).toString(16)).slice(-8) +
      ('00000000' + (h1[1] >>> 0).toString(16)).slice(-8) +
      ('00000000' + (h2[0] >>> 0).toString(16)).slice(-8) +
      ('00000000' + (h2[1] >>> 0).toString(16)).slice(-8)
    )
  }

  loadSources( sources, sourceOptions, loopReleaseInterval = 16 ) {
    const sourcesKey = Object.keys(sources)
    const releaseEventLoop = () => {
      return new Promise(( resolve ) => {
        const channel = new MessageChannel()
        channel.port1.onmessage = () => resolve()
        channel.port2.postMessage(null)
      })
    }
    const suppressUnhandledRejectionWarning = ( promise ) => {
      promise.then(undefined, () => undefined)
      return promise
    }
    const mapWithBreaks = async ( items, callback, loopReleaseInterval = 16 ) => {
      const results = Array(items.length)
      let lastLoopReleaseTime = Date.now()
      for (let i = 0; i < items.length; ++i) {
        results[i] = callback(items[i], i)
        const now = Date.now()
        if (now >= lastLoopReleaseTime + loopReleaseInterval) {
          lastLoopReleaseTime = now
          await releaseEventLoop()
        }
      }

      return results
    }
    const awaitIfAsync = ( action, callback ) => {
      try {
        const returnedValue = action()
        if (!!returnedValue && typeof returnedValue.then === 'function') {
          returnedValue.then(
            ( result ) => callback(true, result),
            ( error ) => callback(false, error),
          )
        } else {
          callback(true, returnedValue)
        }
      } catch (error) {
        callback(false, error)
      }
    }
    const loadSourceItem = ( sourceItem, sourceOptions ) => {
      const sourceLoadPromise = suppressUnhandledRejectionWarning(
        new Promise(( resolveLoad ) => {
          const loadStartTime = Date.now()
          awaitIfAsync(sourceItem.bind(null, sourceOptions), ( ...loadArgs ) => {
            const loadDuration = Date.now() - loadStartTime
            if (!loadArgs[0]) {
              return resolveLoad(() => ({ error: loadArgs[1], duration: loadDuration }))
            }
            const loadResult = loadArgs[1]
            if (typeof loadResult !== 'function') {
              return resolveLoad(() => ({ value: loadResult, duration: loadDuration }))
            }
            resolveLoad(
              () =>
                new Promise(( resolveGet ) => {
                  const getStartTime = Date.now()
                  awaitIfAsync(loadResult, ( ...getArgs ) => {
                    const duration = loadDuration + Date.now() - getStartTime
                    if (!getArgs[0]) {
                      return resolveGet({ error: getArgs[1], duration })
                    }
                    resolveGet({ value: getArgs[1], duration })
                  })
                }),
            )
          })
        }),
      )
      return function getComponent() {
        return sourceLoadPromise.then(( finalizeSource ) => finalizeSource())
      }
    }

    const sourceGettersPromise = suppressUnhandledRejectionWarning(
      mapWithBreaks(sourcesKey, ( sourceItemKey ) => loadSourceItem(sources[sourceItemKey], sourceOptions), loopReleaseInterval),
    )
    return async function getComponents() {
      const sourceGetters = await sourceGettersPromise
      const componentPromises = await mapWithBreaks(
        sourceGetters,
        ( sourceGetter ) => suppressUnhandledRejectionWarning(sourceGetter()),
        loopReleaseInterval,
      )

      const componentArray = await Promise.all(componentPromises)
      const components = {}
      for (let index = 0; index < sourcesKey.length; ++index) {
        components[sourcesKey[index]] = componentArray[index]
      }
      return components
    }
  }

  async withIframe( action, initialHtml, domPollInterval = 50 ) {
    const wait = ( ms ) => new Promise(( r ) => setTimeout(r, ms));
    const d = document
    while (!d.body) {
      await wait(domPollInterval)
    }
    const iframe = d.createElement('iframe')
    try {
      await new Promise(( _resolve, _reject ) => {
        let isComplete = false
        const resolve = () => {
          isComplete = true
          _resolve()
        }
        const reject = ( error ) => {
          isComplete = true
          _reject(error)
        }
        iframe.onload = resolve
        iframe.onerror = reject
        const { style } = iframe
        style.setProperty('display', 'block', 'important') // Required for browsers to calculate the layout
        style.position = 'absolute'
        style.top = '0'
        style.left = '0'
        style.visibility = 'hidden'
        if (initialHtml && 'srcdoc' in iframe) {
          iframe.srcdoc = initialHtml
        } else {
          iframe.src = 'about:blank'
        }
        d.body.appendChild(iframe)
        const checkReadyState = () => {
          if (isComplete) {
            return
          }
          if (iframe.contentWindow?.document?.readyState === 'complete') {
            resolve()
          } else {
            setTimeout(checkReadyState, 10)
          }
        }
        checkReadyState()
      })
      while (!iframe.contentWindow?.document?.body) {
        await wait(domPollInterval)
      }
      return await action(iframe, iframe.contentWindow)
    } finally {
      iframe.parentNode?.removeChild(iframe)
    }
  }

  getFilters() {
    const fromB64 = atob // Just for better minification
    return {
      abpIndo: [
        '#Iklan-Melayang',
        '#Kolom-Iklan-728',
        '#SidebarIklan-wrapper',
        '[title="ALIENBOLA" i]',
        fromB64('I0JveC1CYW5uZXItYWRz'),
      ],
      abpvn: ['.quangcao', '#mobileCatfish', fromB64('LmNsb3NlLWFkcw=='), '[id^="bn_bottom_fixed_"]', '#pmadv'],
      adBlockFinland: [
        '.mainostila',
        fromB64('LnNwb25zb3JpdA=='),
        '.ylamainos',
        fromB64('YVtocmVmKj0iL2NsaWNrdGhyZ2guYXNwPyJd'),
        fromB64('YVtocmVmXj0iaHR0cHM6Ly9hcHAucmVhZHBlYWsuY29tL2FkcyJd'),
      ],
      adBlockPersian: [
        '#navbar_notice_50',
        '.kadr',
        'TABLE[width="140px"]',
        '#divAgahi',
        fromB64('YVtocmVmXj0iaHR0cDovL2cxLnYuZndtcm0ubmV0L2FkLyJd'),
      ],
      adBlockWarningRemoval: [
        '#adblock-honeypot',
        '.adblocker-root',
        '.wp_adblock_detect',
        fromB64('LmhlYWRlci1ibG9ja2VkLWFk'),
        fromB64('I2FkX2Jsb2NrZXI='),
      ],
      adGuardAnnoyances: [
        '.hs-sosyal',
        '#cookieconsentdiv',
        'div[class^="app_gdpr"]',
        '.as-oil',
        '[data-cypress="soft-push-notification-modal"]',
      ],
      adGuardBase: [
        '.BetterJsPopOverlay',
        fromB64('I2FkXzMwMFgyNTA='),
        fromB64('I2Jhbm5lcmZsb2F0MjI='),
        fromB64('I2NhbXBhaWduLWJhbm5lcg=='),
        fromB64('I0FkLUNvbnRlbnQ='),
      ],
      adGuardChinese: [
        fromB64('LlppX2FkX2FfSA=='),
        fromB64('YVtocmVmKj0iLmh0aGJldDM0LmNvbSJd'),
        '#widget-quan',
        fromB64('YVtocmVmKj0iLzg0OTkyMDIwLnh5eiJd'),
        fromB64('YVtocmVmKj0iLjE5NTZobC5jb20vIl0='),
      ],
      adGuardFrench: [
        '#pavePub',
        fromB64('LmFkLWRlc2t0b3AtcmVjdGFuZ2xl'),
        '.mobile_adhesion',
        '.widgetadv',
        fromB64('LmFkc19iYW4='),
      ],
      adGuardGerman: ['aside[data-portal-id="leaderboard"]'],
      adGuardJapanese: [
        '#kauli_yad_1',
        fromB64('YVtocmVmXj0iaHR0cDovL2FkMi50cmFmZmljZ2F0ZS5uZXQvIl0='),
        fromB64('Ll9wb3BJbl9pbmZpbml0ZV9hZA=='),
        fromB64('LmFkZ29vZ2xl'),
        fromB64('Ll9faXNib29zdFJldHVybkFk'),
      ],
      adGuardMobile: [
        fromB64('YW1wLWF1dG8tYWRz'),
        fromB64('LmFtcF9hZA=='),
        'amp-embed[type="24smi"]',
        '#mgid_iframe1',
        fromB64('I2FkX2ludmlld19hcmVh'),
      ],
      adGuardRussian: [
        fromB64('YVtocmVmXj0iaHR0cHM6Ly9hZC5sZXRtZWFkcy5jb20vIl0='),
        fromB64('LnJlY2xhbWE='),
        'div[id^="smi2adblock"]',
        fromB64('ZGl2W2lkXj0iQWRGb3hfYmFubmVyXyJd'),
        '#psyduckpockeball',
      ],
      adGuardSocial: [
        fromB64('YVtocmVmXj0iLy93d3cuc3R1bWJsZXVwb24uY29tL3N1Ym1pdD91cmw9Il0='),
        fromB64('YVtocmVmXj0iLy90ZWxlZ3JhbS5tZS9zaGFyZS91cmw/Il0='),
        '.etsy-tweet',
        '#inlineShare',
        '.popup-social',
      ],
      adGuardSpanishPortuguese: ['#barraPublicidade', '#Publicidade', '#publiEspecial', '#queTooltip', '.cnt-publi'],
      adGuardTrackingProtection: [
        '#qoo-counter',
        fromB64('YVtocmVmXj0iaHR0cDovL2NsaWNrLmhvdGxvZy5ydS8iXQ=='),
        fromB64('YVtocmVmXj0iaHR0cDovL2hpdGNvdW50ZXIucnUvdG9wL3N0YXQucGhwIl0='),
        fromB64('YVtocmVmXj0iaHR0cDovL3RvcC5tYWlsLnJ1L2p1bXAiXQ=='),
        '#top100counter',
      ],
      adGuardTurkish: [
        '#backkapat',
        fromB64('I3Jla2xhbWk='),
        fromB64('YVtocmVmXj0iaHR0cDovL2Fkc2Vydi5vbnRlay5jb20udHIvIl0='),
        fromB64('YVtocmVmXj0iaHR0cDovL2l6bGVuemkuY29tL2NhbXBhaWduLyJd'),
        fromB64('YVtocmVmXj0iaHR0cDovL3d3dy5pbnN0YWxsYWRzLm5ldC8iXQ=='),
      ],
      bulgarian: [fromB64('dGQjZnJlZW5ldF90YWJsZV9hZHM='), '#ea_intext_div', '.lapni-pop-over', '#xenium_hot_offers'],
      easyList: [
        '.yb-floorad',
        fromB64('LndpZGdldF9wb19hZHNfd2lkZ2V0'),
        fromB64('LnRyYWZmaWNqdW5reS1hZA=='),
        '.textad_headline',
        fromB64('LnNwb25zb3JlZC10ZXh0LWxpbmtz'),
      ],
      easyListChina: [
        fromB64('LmFwcGd1aWRlLXdyYXBbb25jbGljayo9ImJjZWJvcy5jb20iXQ=='),
        fromB64('LmZyb250cGFnZUFkdk0='),
        '#taotaole',
        '#aafoot.top_box',
        '.cfa_popup',
      ],
      easyListCookie: [
        '.ezmob-footer',
        '.cc-CookieWarning',
        '[data-cookie-number]',
        fromB64('LmF3LWNvb2tpZS1iYW5uZXI='),
        '.sygnal24-gdpr-modal-wrap',
      ],
      easyListCzechSlovak: [
        '#onlajny-stickers',
        fromB64('I3Jla2xhbW5pLWJveA=='),
        fromB64('LnJla2xhbWEtbWVnYWJvYXJk'),
        '.sklik',
        fromB64('W2lkXj0ic2tsaWtSZWtsYW1hIl0='),
      ],
      easyListDutch: [
        fromB64('I2FkdmVydGVudGll'),
        fromB64('I3ZpcEFkbWFya3RCYW5uZXJCbG9jaw=='),
        '.adstekst',
        fromB64('YVtocmVmXj0iaHR0cHM6Ly94bHR1YmUubmwvY2xpY2svIl0='),
        '#semilo-lrectangle',
      ],
      easyListGermany: [
        '#SSpotIMPopSlider',
        fromB64('LnNwb25zb3JsaW5rZ3J1ZW4='),
        fromB64('I3dlcmJ1bmdza3k='),
        fromB64('I3Jla2xhbWUtcmVjaHRzLW1pdHRl'),
        fromB64('YVtocmVmXj0iaHR0cHM6Ly9iZDc0Mi5jb20vIl0='),
      ],
      easyListItaly: [
        fromB64('LmJveF9hZHZfYW5udW5jaQ=='),
        '.sb-box-pubbliredazionale',
        fromB64('YVtocmVmXj0iaHR0cDovL2FmZmlsaWF6aW9uaWFkcy5zbmFpLml0LyJd'),
        fromB64('YVtocmVmXj0iaHR0cHM6Ly9hZHNlcnZlci5odG1sLml0LyJd'),
        fromB64('YVtocmVmXj0iaHR0cHM6Ly9hZmZpbGlhemlvbmlhZHMuc25haS5pdC8iXQ=='),
      ],
      easyListLithuania: [
        fromB64('LnJla2xhbW9zX3RhcnBhcw=='),
        fromB64('LnJla2xhbW9zX251b3JvZG9z'),
        fromB64('aW1nW2FsdD0iUmVrbGFtaW5pcyBza3lkZWxpcyJd'),
        fromB64('aW1nW2FsdD0iRGVkaWt1b3RpLmx0IHNlcnZlcmlhaSJd'),
        fromB64('aW1nW2FsdD0iSG9zdGluZ2FzIFNlcnZlcmlhaS5sdCJd'),
      ],
      estonian: [fromB64('QVtocmVmKj0iaHR0cDovL3BheTRyZXN1bHRzMjQuZXUiXQ==')],
      fanboyAnnoyances: ['#ac-lre-player', '.navigate-to-top', '#subscribe_popup', '.newsletter_holder', '#back-top'],
      fanboyAntiFacebook: ['.util-bar-module-firefly-visible'],
      fanboyEnhancedTrackers: [
        '.open.pushModal',
        '#issuem-leaky-paywall-articles-zero-remaining-nag',
        '#sovrn_container',
        'div[class$="-hide"][zoompage-fontsize][style="display: block;"]',
        '.BlockNag__Card',
      ],
      fanboySocial: ['#FollowUs', '#meteored_share', '#social_follow', '.article-sharer', '.community__social-desc'],
      frellwitSwedish: [
        fromB64('YVtocmVmKj0iY2FzaW5vcHJvLnNlIl1bdGFyZ2V0PSJfYmxhbmsiXQ=='),
        fromB64('YVtocmVmKj0iZG9rdG9yLXNlLm9uZWxpbmsubWUiXQ=='),
        'article.category-samarbete',
        fromB64('ZGl2LmhvbGlkQWRz'),
        'ul.adsmodern',
      ],
      greekAdBlock: [
        fromB64('QVtocmVmKj0iYWRtYW4ub3RlbmV0LmdyL2NsaWNrPyJd'),
        fromB64('QVtocmVmKj0iaHR0cDovL2F4aWFiYW5uZXJzLmV4b2R1cy5nci8iXQ=='),
        fromB64('QVtocmVmKj0iaHR0cDovL2ludGVyYWN0aXZlLmZvcnRobmV0LmdyL2NsaWNrPyJd'),
        'DIV.agores300',
        'TABLE.advright',
      ],
      hungarian: [
        '#cemp_doboz',
        '.optimonk-iframe-container',
        fromB64('LmFkX19tYWlu'),
        fromB64('W2NsYXNzKj0iR29vZ2xlQWRzIl0='),
        '#hirdetesek_box',
      ],
      iDontCareAboutCookies: [
        '.alert-info[data-block-track*="CookieNotice"]',
        '.ModuleTemplateCookieIndicator',
        '.o--cookies--container',
        '#cookies-policy-sticky',
        '#stickyCookieBar',
      ],
      icelandicAbp: [fromB64('QVtocmVmXj0iL2ZyYW1ld29yay9yZXNvdXJjZXMvZm9ybXMvYWRzLmFzcHgiXQ==')],
      latvian: [
        fromB64(
          'YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiAxMjBweDsgaGVpZ2h0O' +
          'iA0MHB4OyBvdmVyZmxvdzogaGlkZGVuOyBwb3NpdGlvbjogcmVsYXRpdmU7Il0=',
        ),
        fromB64(
          'YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiA4OHB4OyBoZWlnaHQ6I' +
          'DMxcHg7IG92ZXJmbG93OiBoaWRkZW47IHBvc2l0aW9uOiByZWxhdGl2ZTsiXQ==',
        ),
      ],
      listKr: [
        fromB64('YVtocmVmKj0iLy9hZC5wbGFuYnBsdXMuY28ua3IvIl0='),
        fromB64('I2xpdmVyZUFkV3JhcHBlcg=='),
        fromB64('YVtocmVmKj0iLy9hZHYuaW1hZHJlcC5jby5rci8iXQ=='),
        fromB64('aW5zLmZhc3R2aWV3LWFk'),
        '.revenue_unit_item.dable',
      ],
      listeAr: [
        fromB64('LmdlbWluaUxCMUFk'),
        '.right-and-left-sponsers',
        fromB64('YVtocmVmKj0iLmFmbGFtLmluZm8iXQ=='),
        fromB64('YVtocmVmKj0iYm9vcmFxLm9yZyJd'),
        fromB64('YVtocmVmKj0iZHViaXp6bGUuY29tL2FyLz91dG1fc291cmNlPSJd'),
      ],
      listeFr: [
        fromB64('YVtocmVmXj0iaHR0cDovL3Byb21vLnZhZG9yLmNvbS8iXQ=='),
        fromB64('I2FkY29udGFpbmVyX3JlY2hlcmNoZQ=='),
        fromB64('YVtocmVmKj0id2Vib3JhbWEuZnIvZmNnaS1iaW4vIl0='),
        '.site-pub-interstitiel',
        'div[id^="crt-"][data-criteo-id]',
      ],
      officialPolish: [
        '#ceneo-placeholder-ceneo-12',
        fromB64('W2hyZWZePSJodHRwczovL2FmZi5zZW5kaHViLnBsLyJd'),
        fromB64('YVtocmVmXj0iaHR0cDovL2Fkdm1hbmFnZXIudGVjaGZ1bi5wbC9yZWRpcmVjdC8iXQ=='),
        fromB64('YVtocmVmXj0iaHR0cDovL3d3dy50cml6ZXIucGwvP3V0bV9zb3VyY2UiXQ=='),
        fromB64('ZGl2I3NrYXBpZWNfYWQ='),
      ],
      ro: [
        fromB64('YVtocmVmXj0iLy9hZmZ0cmsuYWx0ZXgucm8vQ291bnRlci9DbGljayJd'),
        fromB64('YVtocmVmXj0iaHR0cHM6Ly9ibGFja2ZyaWRheXNhbGVzLnJvL3Ryay9zaG9wLyJd'),
        fromB64('YVtocmVmXj0iaHR0cHM6Ly9ldmVudC4ycGVyZm9ybWFudC5jb20vZXZlbnRzL2NsaWNrIl0='),
        fromB64('YVtocmVmXj0iaHR0cHM6Ly9sLnByb2ZpdHNoYXJlLnJvLyJd'),
        'a[href^="/url/"]',
      ],
      ruAd: [
        fromB64('YVtocmVmKj0iLy9mZWJyYXJlLnJ1LyJd'),
        fromB64('YVtocmVmKj0iLy91dGltZy5ydS8iXQ=='),
        fromB64('YVtocmVmKj0iOi8vY2hpa2lkaWtpLnJ1Il0='),
        '#pgeldiz',
        '.yandex-rtb-block',
      ],
      thaiAds: [
        'a[href*=macau-uta-popup]',
        fromB64('I2Fkcy1nb29nbGUtbWlkZGxlX3JlY3RhbmdsZS1ncm91cA=='),
        fromB64('LmFkczMwMHM='),
        '.bumq',
        '.img-kosana',
      ],
      webAnnoyancesUltralist: [
        '#mod-social-share-2',
        '#social-tools',
        fromB64('LmN0cGwtZnVsbGJhbm5lcg=='),
        '.zergnet-recommend',
        '.yt.btn-link.btn-md.btn',
      ],
    }
  }

  countTruthy( values ) {
    return values.reduce(( sum, value ) => sum + (value ? 1 : 0), 0)
  }

  exitFullscreen() {
    const d = document
    return (d.exitFullscreen || d.msExitFullscreen || d.mozCancelFullScreen || d.webkitExitFullscreen).call(d)
  }

  getFullscreenElement() {
    const d = document
    return d.fullscreenElement || d.msFullscreenElement || d.mozFullScreenElement || d.webkitFullscreenElement || null
  }

  // 浏览器类型
  browserType() {
    const w = window
    const d = document
    const s = screen
    const n = navigator
    const screenRatio = s.width / s.height
    const { URLPattern, CSS, HTMLButtonElement, visualViewport } = window
    const audioPrototype = Audio.prototype
    this.isTrident = this.countTruthy([
      'MSCSSMatrix' in w,
      'msSetImmediate' in w,
      'msIndexedDB' in w,
      'msMaxTouchPoints' in n,
      'msPointerEnabled' in n,
    ]) >= 4;
    this.isEdgeHTML = this.countTruthy([
      'msWriteProfilerMark' in w,
      'MSStream' in w,
      'msLaunchUri' in n, '' +
      'msSaveBlob' in n
    ]) >= 3 && !this.isTrident;
    this.isChromium = this.countTruthy([
      'webkitPersistentStorage' in n,
      'webkitTemporaryStorage' in n,
      (n.vendor || '').indexOf('Google') === 0,
      'webkitResolveLocalFileSystemURL' in w,
      'BatteryManager' in w,
      'webkitMediaStream' in w,
      'webkitSpeechGrammar' in w,
    ]) >= 5;
    this.isWebKit = this.countTruthy([
      'ApplePayError' in w,
      'CSSPrimitiveValue' in w,
      'Counter' in w,
      n.vendor.indexOf('Apple') === 0,
      'RGBColor' in w,
      'WebKitMediaKeys' in w,
    ]) >= 4;
    this.isDesktopWebKit = this.countTruthy([
      'safari' in w,
      !('ongestureend' in w),
      !('TouchEvent' in w),
      !('orientation' in w),
      HTMLElement && !('autocapitalize' in HTMLElement.prototype),
      Document && 'pointerLockElement' in Document.prototype,
    ]) >= 4;
    this.isGecko = this.countTruthy([
      'buildID' in navigator,
      'MozAppearance' in (document.documentElement?.style ?? {}),
      'onmozfullscreenchange' in w,
      'mozInnerScreenX' in w,
      'CSSMozDocumentRule' in w,
      'CanvasCaptureMediaStream' in w,
    ]) >= 4;
    this.isChromium86OrNewer = this.countTruthy([
      !('MediaSettingsRange' in w),
      'RTCEncodedAudioFrame' in w,
      '' + w.Intl === '[object Intl]',
      '' + w.Reflect === '[object Reflect]',
    ]) >= 3;
    this.isChromium122OrNewer = this.countTruthy([
      'union' in Set.prototype,
      'Iterator' in w,
      URLPattern && 'hasRegExpGroups' in URLPattern.prototype,
      'RGB8' in WebGLRenderingContext.prototype,
    ]) >= 3;
    this.isWebKit606OrNewer = this.countTruthy([
      'DOMRectList' in w,
      'RTCPeerConnectionIceEvent' in w,
      'SVGGeometryElement' in w,
      'ontransitioncancel' in w,
    ]) >= 3;
    this.isWebKit616OrNewer = this.countTruthy([
      !('getStorageUpdates' in n),
      HTMLButtonElement && 'popover' in HTMLButtonElement.prototype,
      'CSSCounterStyleRule' in w,
      CSS.supports('font-size-adjust: ex-height 0.5'),
      CSS.supports('text-transform: full-width'),
    ]) >= 4;
    this.isIPad = navigator.platform === 'iPad' || this.countTruthy([
      'MediaSource' in window,
      !!Element.prototype.webkitRequestFullscreen,
      screenRatio > 0.65 && screenRatio < 1.53,
    ]) >= 2
    this.isSafariWebKit = /^function\s.*?\{\s*\[native code]\s*}$/.test(String(w.print))
      && String(w.browser) === '[object WebPageNamespace]'
    this.isSamsungInternet = this.countTruthy([
      'srLatency' in audioPrototype,
      'srChannelCount' in audioPrototype,
      'devicePosture' in n,
      visualViewport && 'segments' in visualViewport,
      'getTextInformation' in Image.prototype,
    ]) >= 3;
    if (this.isChromium) {
      this.isAndroid = this.countTruthy([
        !('SharedWorker' in w),
        // `typechange` is deprecated, but it's still present on Android (tested on Chrome Mobile 117)
        // Removal proposal https://bugs.chromium.org/p/chromium/issues/detail?id=699892
        // Note: this expression returns true on ChromeOS, so additional detectors are required to avoid false-positives
        n[c] && 'ontypechange' in n[c],
        !('sinkId' in new Audio()),
      ]) >= 2;
    } else if (this.isGecko) {
      this.isAndroid = this.countTruthy(['onorientationchange' in w, 'orientation' in w, /android/i.test(n.appVersion)]) >= 2
    } else {
      this.isAndroid = false;
    }
  }

  /*用户 对比度设置*/
  getContrastPreference() {
    const doesMatch = value => (
      matchMedia(`(prefers-contrast: ${value})`).matches
    )
    if (doesMatch('no-preference')) {
      return 0
    } else if (doesMatch('high') || doesMatch('more')) {
      return 1
    } else if (doesMatch('low') || doesMatch('less')) {
      return -1
    } else if (doesMatch('forced')) {
      return 10
    } else {
      return undefined
    }
  }

  /*用户 强制色设置*/
  areColorsForced() {
    if (matchMedia(`(forced-colors: active)`).matches) {
      return true
    } else if (matchMedia(`(forced-colors: none)`).matches) {
      return false
    } else {
      return undefined
    }
  }

  /*用户 减少动画设置*/
  isMotionReduced() {
    const doesMatch = value => (
      matchMedia(`(prefers-reduced-motion: ${value})`).matches
    )
    if (doesMatch('reduce')) {
      return true
    } else if (doesMatch('no-preference')) {
      return false
    } else {
      return undefined
    }
  }

  /*用户 减少透明度设置*/
  isTransparencyReduced() {
    const doesMatch = value => (
      matchMedia(`(prefers-reduced-transparency: ${value})`).matches
    )
    if (doesMatch('reduce')) {
      return true
    } else if (doesMatch('no-preference')) {
      return false
    } else {
      return undefined
    }
  }

  /*用户 HDR设置*/
  isHDR() {
    const doesMatch = value => (
      matchMedia(`(dynamic-range: ${value})`).matches
    )
    if (doesMatch('high')) {
      return true
    } else if (doesMatch('standard')) {
      return false
    } else {
      return undefined
    }
  }

  /*用户 反色设置*/
  areColorsInverted() {
    const doesMatch = value => (
      matchMedia(`(inverted-colors: ${value})`).matches
    )
    if (doesMatch('inverted')) {
      return true
    } else if (doesMatch('none')) {
      return false
    } else {
      return undefined
    }
  }

  /*系统 cpuClass 老IE*/
  getCpuClass() {
    return navigator.cpuClass
  }

  /*系统 osCpu 主要是firefox*/
  getOsCpu() {
    return navigator.oscpu
  }

  /*系统 平台*/
  getPlatform() {
    const { platform } = navigator
    if (platform === 'MacIntel') {
      if (this.isWebKit && !this.isDesktopWebKit) {
        return this.isIPad ? 'iPad' : 'iPhone'
      }
    }
    return platform
  }

  /*系统 内存大小*/
  getDeviceMemory() {
    const mem = parseFloat(navigator.deviceMemory)
    return typeof mem === 'number' && !isNaN(mem) ? mem : undefined;
  }

  /*系统 CPU 核心数*/
  getHardwareConcurrency() {
    const hc = parseFloat(navigator.hardwareConcurrency)
    return typeof hc === 'number' && !isNaN(hc) ? hc : undefined;
  }

  /*系统 字节序 区别于 Big-Endian 与 Little-Endian */
  getArchitecture() {
    const f = new Float32Array(1)
    const u8 = new Uint8Array(f.buffer)
    f[0] = Infinity
    f[0] = f[0] - f[0]
    return u8[3]
  }

  /*系统 颜色深度*/
  getColorDepth() {
    return window.screen.colorDepth
  }

  /*系统 最大支持的色域*/
  getColorGamut() {
    for (const gamut of ['rec2020', 'p3', 'srgb']) {
      if (matchMedia(`(color-gamut: ${gamut})`).matches) {
        return gamut
      }
    }
    return undefined
  }

  /*系统 单色显示深度*/
  getMonochromeDepth = () => {
    const maxValueToCheck = 100
    if (!matchMedia('(min-monochrome: 0)').matches) {
      return undefined
    }
    for (let i = 0; i <= maxValueToCheck; ++i) {
      if (matchMedia(`(max-monochrome: ${i})`).matches) {
        return i
      }
    }
    throw new Error('Too high value')
  }

  /*系统 屏幕分辨率*/
  getScreenResolution() {
    if (this.isWebKit && this.isWebKit616OrNewer && this.isSafariWebKit) {
      return undefined
    }
    const s = screen
    const parseDimension = value => {
      const intValue = parseInt(value)
      return typeof intValue === 'number' && isNaN(intValue) ? null : intValue
    }
    const dimensions = [parseDimension(s.width), parseDimension(s.height)]
    dimensions.sort().reverse()
    return dimensions
  }

  /*系统 触摸*/
  getTouchSupport() {
    const n = navigator
    let maxTouchPoints = 0
    let touchEvent
    if (n.maxTouchPoints !== undefined) {
      maxTouchPoints = parseInt(n.maxTouchPoints)
    } else if (n.msMaxTouchPoints !== undefined) {
      maxTouchPoints = n.msMaxTouchPoints
    }
    try {
      document.createEvent('TouchEvent')
      touchEvent = true
    } catch {
      touchEvent = false
    }
    const touchStart = 'ontouchstart' in window
    return {
      maxTouchPoints,
      touchEvent,
      touchStart,
    }
  }

  /*地区 语言*/
  getLanguages() {
    const n = navigator
    const result = []
    const language = n.language || n.userLanguage || n.browserLanguage || n.systemLanguage
    if (language !== undefined) {
      result.push([language])
    }
    if (Array.isArray(n.languages)) {
      if (!(this.isChromium && this.isChromium86OrNewer)) {
        result.push(n.languages)
      }
    } else if (typeof n.languages === 'string') {
      const languages = n.languages
      if (languages) {
        result.push(languages.split(','))
      }
    }
    return result
  }

  /*地区 本地时间*/
  getDateTimeLocale() {
    if (!window.Intl) {
      return -1
    }
    const DateTimeFormat = window.Intl.DateTimeFormat
    if (!DateTimeFormat) {
      return -2
    }
    const locale = DateTimeFormat().resolvedOptions().locale
    if (!locale && locale !== '') {
      return -3
    }
    return locale
  }

  /*地区 时区*/
  getTimezone() {
    const getTimezoneOffset = () => {
      const currentYear = new Date().getFullYear()
      return Math.max(
        parseFloat(new Date(currentYear, 0, 1).getTimezoneOffset()),
        parseFloat(new Date(currentYear, 6, 1).getTimezoneOffset()),
      )
    }
    const DateTimeFormat = window.Intl?.DateTimeFormat
    if (DateTimeFormat) {
      const timezone = new DateTimeFormat().resolvedOptions().timeZone
      if (timezone) {
        return timezone
      }
    }
    const offset = -getTimezoneOffset()
    return `UTC${offset >= 0 ? '+' : ''}${offset}`
  }

  /*浏览器 cookie*/
  areCookiesEnabled() {
    try {
      document.cookie = 'cookietest=1; SameSite=Strict;'
      const result = document.cookie.indexOf('cookietest=') !== -1
      document.cookie = 'cookietest=1; SameSite=Strict; expires=Thu, 01-Jan-1970 00:00:01 GMT'
      return result
    } catch (e) {
      return false
    }
  }

  /*浏览器 SessionStorage*/
  areSessionStorage() {
    try {
      return !!window.sessionStorage
    } catch (error) {
      return true
    }
  }

  /*浏览器 localStorage*/
  areLocalStorage() {
    try {
      return !!window.localStorage
    } catch (e) {
      return true
    }
  }

  /*浏览器 indexedDB*/
  areIndexedDB() {
    if (this.isTrident || this.isEdgeHTML) {
      return undefined
    }
    try {
      return !!window.indexedDB
    } catch (e) {
      return true
    }
  }

  /*浏览器 openDatabase*/
  areOpenDatabase() {
    return !!window.openDatabase
  }

  /*浏览器 Safari 的点击归因机制*/
  getPrivateClickMeasurement() {
    const link = document.createElement('a');
    const sourceId = link.attributionSourceId ?? link.attributionsourceid;
    return sourceId === undefined ? undefined : String(sourceId);
  }

  /*浏览器 是否支持 Apple Pay*/
  getApplePayState() {
    const { ApplePaySession } = window
    const willPrintConsoleError = () => {
      let currentWindow = window
      for (; ;) {
        const parentWindow = currentWindow.parent
        if (!parentWindow || parentWindow === currentWindow) {
          return false // The top page is reached
        }
        try {
          if (parentWindow.location.origin !== currentWindow.location.origin) {
            return true
          }
        } catch (error) {
          if (error instanceof Error && error.name === 'SecurityError') {
            return true
          }
          throw error
        }
        currentWindow = parentWindow
      }
    }
    if (typeof ApplePaySession?.canMakePayments !== 'function') {
      return -1
    } else if (willPrintConsoleError()) {
      return -3
    }
    try {
      return ApplePaySession.canMakePayments() ? 1 : 0
    } catch (error) {
      if (error instanceof Error && error.name === 'InvalidAccessError' && /\bfrom\b.*\binsecure\b/i.test(error.message)) {
        return -2
      }
      throw error
    }
  }

  /*浏览器 供应商*/
  getVendor() {
    return navigator.vendor || ''
  }

  /*浏览器 供应商特征*/
  getVendorFlavors() {
    const flavors = []
    for (const key of [
      // Blink and some browsers on iOS
      'chrome',
      // Safari on macOS
      'safari',
      // Chrome on iOS (checked in 85 on 13 and 87 on 14)
      '__crWeb',
      '__gCrWeb',
      // Yandex Browser on iOS, macOS and Android (checked in 21.2 on iOS 14, macOS and Android)
      'yandex',
      // Yandex Browser on iOS (checked in 21.2 on 14)
      '__yb',
      '__ybro',
      // Firefox on iOS (checked in 32 on 14)
      '__firefox__',
      // Edge on iOS (checked in 46 on 14)
      '__edgeTrackingPreventionStatistics',
      'webkit',
      // Opera Touch on iOS (checked in 2.6 on 14)
      'oprt',
      // Samsung Internet on Android (checked in 11.1)
      'samsungAr',
      // UC Browser on Android (checked in 12.10 and 13.0)
      'ucweb',
      'UCShellJava',
      // Puffin on Android (checked in 9.0)
      'puffinDevice',
      // UC on iOS and Opera on Android have no specific global variables
      // Edge for Android isn't checked
    ]) {
      const value = window[key]
      if (value && typeof value === 'object') {
        flavors.push(key)
      }
    }
    return flavors.sort()
  }

  /*浏览器 插件信息*/
  getPlugins() {
    const rawPlugins = navigator.plugins
    if (!rawPlugins) {
      return undefined
    }
    const plugins = []
    for (let i = 0; i < rawPlugins.length; ++i) {
      const plugin = rawPlugins[i]
      if (!plugin) {
        continue
      }
      const mimeTypes = []
      for (let j = 0; j < plugin.length; ++j) {
        const mimeType = plugin[j]
        mimeTypes.push({
          type: mimeType.type,
          suffixes: mimeType.suffixes,
        })
      }
      plugins.push({
        name: plugin.name,
        description: plugin.description,
        mimeTypes,
      })
    }
    return plugins
  }

  /*浏览器 内置PDF*/
  isPdfViewerEnabled() {
    return navigator.pdfViewerEnabled
  }

  /*Canvas 指纹*/
  getUnstableCanvasFingerprint() {
    const skipImages = this.isWebKit && this.isWebKit616OrNewer && this.isSafariWebKit
    const canvasToString = ( canvas ) => canvas.toDataURL()
    const renderTextImage = ( canvas, context ) => {
      canvas.width = 240
      canvas.height = 60
      context.textBaseline = 'alphabetic'
      context.fillStyle = '#f60'
      context.fillRect(100, 1, 62, 20)
      context.fillStyle = '#069'
      context.font = '11pt "Times New Roman"'
      // const printedText = `Sphinx of black quartz 🦊`
      const printedText = `Cwm fjordbank gly ${String.fromCharCode(55357, 56835) /* 😃 */}`
      context.fillText(printedText, 2, 15)
      context.fillStyle = 'rgba(102, 204, 0, 0.2)'
      context.font = '18pt Arial'
      context.fillText(printedText, 4, 45)
    }
    const renderGeometryImage = ( canvas, context ) => {
      canvas.width = 122
      canvas.height = 110
      context.globalCompositeOperation = 'multiply'
      for (const [color, x, y] of [
        ['#f2f', 40, 40],
        ['#2ff', 80, 40],
        ['#ff2', 60, 80],
      ]) {
        context.fillStyle = color
        context.beginPath()
        context.arc(x, y, 40, 0, Math.PI * 2, true)
        context.closePath()
        context.fill()
      }
      context.fillStyle = '#f9c'
      context.arc(60, 60, 60, 0, Math.PI * 2, true)
      context.arc(60, 60, 20, 0, Math.PI * 2, true)
      context.fill('evenodd')
    }
    const renderImages = ( canvas, context ) => {
      renderTextImage(canvas, context)
      const textImage1 = canvasToString(canvas)
      const textImage2 = canvasToString(canvas)
      if (textImage1 !== textImage2) {
        return ['unsupported', 'unstable']
      }
      renderGeometryImage(canvas, context)
      const geometryImage = canvasToString(canvas)
      return [geometryImage, textImage1]
    }
    let winding = false
    let geometry
    let text
    const canvas = document.createElement('canvas')
    canvas.width = 1
    canvas.height = 1
    const context = canvas.getContext('2d')
    if (!(context && canvas.toDataURL)) {
      geometry = text = 'unsupported'
    } else {
      context.rect(0, 0, 10, 10)
      context.rect(2, 2, 6, 6)
      winding = !context.isPointInPath(5, 5, 'evenodd')
      if (skipImages) {
        geometry = text = 'skipped'
      } else {
        ;[geometry, text] = renderImages(canvas, context)
      }
    }
    return { winding, geometry, text }
  }

  /*音频 延迟*/
  getAudioContextBaseLatency() {
    const isAllowedPlatform = this.isAndroid || this.isWebKit
    if (!isAllowedPlatform) {
      return -2
    }
    if (!window.AudioContext) {
      return -1
    }
    const latency = new AudioContext().baseLatency
    if (latency === null || latency === undefined) {
      return -1
    }
    if (!isFinite(latency)) {
      return -3
    }
    return latency
  }

  /*数学函数 指纹*/
  getMathFingerprint() {
    const M = Math
    const fallbackFn = () => 0
    const acos = M.acos || fallbackFn
    const acosh = M.acosh || fallbackFn
    const asin = M.asin || fallbackFn
    const asinh = M.asinh || fallbackFn
    const atanh = M.atanh || fallbackFn
    const atan = M.atan || fallbackFn
    const sin = M.sin || fallbackFn
    const sinh = M.sinh || fallbackFn
    const cos = M.cos || fallbackFn
    const cosh = M.cosh || fallbackFn
    const tan = M.tan || fallbackFn
    const tanh = M.tanh || fallbackFn
    const exp = M.exp || fallbackFn
    const expm1 = M.expm1 || fallbackFn
    const log1p = M.log1p || fallbackFn

    // Operation polyfills
    const powPI = ( value ) => M.pow(M.PI, value)
    const acoshPf = ( value ) => M.log(value + M.sqrt(value * value - 1))
    const asinhPf = ( value ) => M.log(value + M.sqrt(value * value + 1))
    const atanhPf = ( value ) => M.log((1 + value) / (1 - value)) / 2
    const sinhPf = ( value ) => M.exp(value) - 1 / M.exp(value) / 2
    const coshPf = ( value ) => (M.exp(value) + 1 / M.exp(value)) / 2
    const expm1Pf = ( value ) => M.exp(value) - 1
    const tanhPf = ( value ) => (M.exp(2 * value) - 1) / (M.exp(2 * value) + 1)
    const log1pPf = ( value ) => M.log(1 + value)

    return {
      acos: acos(0.123124234234234242),
      acosh: acosh(1e308),
      acoshPf: acoshPf(1e154), // 1e308 will not work for polyfill
      asin: asin(0.123124234234234242),
      asinh: asinh(1),
      asinhPf: asinhPf(1),
      atanh: atanh(0.5),
      atanhPf: atanhPf(0.5),
      atan: atan(0.5),
      sin: sin(-1e300),
      sinh: sinh(1),
      sinhPf: sinhPf(1),
      cos: cos(10.000000000123),
      cosh: cosh(1),
      coshPf: coshPf(1),
      tan: tan(-1e300),
      tanh: tanh(1),
      tanhPf: tanhPf(1),
      exp: exp(1),
      expm1: expm1(1),
      expm1Pf: expm1Pf(1),
      log1p: log1p(10),
      log1pPf: log1pPf(10),
      powPI: powPI(-100),
    }
  }

  /*异步 dom广告拦截器*/
  async getDomBlockers( { debug } = {} ) {
    if (!this.isWebKit && !this.isAndroid) {
      return undefined
    }
    const printDebug = ( filters, blockedSelectors ) => {
      let message = 'DOM blockers debug:\n```'
      for (const filterName of Object.keys(filters)) {
        message += `\n${filterName}:`
        for (const selector of filters[filterName]) {
          message += `\n  ${blockedSelectors[selector] ? '🚫' : '➡️'} ${selector}`
        }
      }
    }
    const forceShow = ( element ) => {
      element.style.setProperty('visibility', 'hidden', 'important')
      element.style.setProperty('display', 'block', 'important')
    }
    const addStyleString = ( style, source ) => {
      for (const property of source.split(';')) {
        const match = /^\s*([\w-]+)\s*:\s*(.+?)(\s*!([\w-]+))?\s*$/.exec(property)
        if (match) {
          const [, name, value, , priority] = match
          style.setProperty(name, value, priority || '') // The last argument can't be undefined in IE11
        }
      }
    }
    const parseSimpleCssSelector = ( selector ) => {
      const errorMessage = `Unexpected syntax '${selector}'`
      const tagMatch = /^\s*([a-z-]*)(.*)$/i.exec(selector)
      const tag = tagMatch[1] || undefined
      const attributes = {}
      const partsRegex = /([.:#][\w-]+|\[.+?\])/gi
      const addAttribute = ( name, value ) => {
        attributes[name] = attributes[name] || []
        attributes[name].push(value)
      }
      for (; ;) {
        const match = partsRegex.exec(tagMatch[2])
        if (!match) {
          break
        }
        const part = match[0]
        switch (part[0]) {
          case '.':
            addAttribute('class', part.slice(1))
            break
          case '#':
            addAttribute('id', part.slice(1))
            break
          case '[': {
            const attributeMatch = /^\[([\w-]+)([~|^$*]?=("(.*?)"|([\w-]+)))?(\s+[is])?\]$/.exec(part)
            if (attributeMatch) {
              addAttribute(attributeMatch[1], attributeMatch[4] ?? attributeMatch[5] ?? '')
            } else {
              throw new Error(errorMessage)
            }
            break
          }
          default:
            throw new Error(errorMessage)
        }
      }
      return [tag, attributes]
    }
    const selectorToElement = ( selector ) => {
      const [tag, attributes] = parseSimpleCssSelector(selector)
      const element = document.createElement(tag ?? 'div')
      for (const name of Object.keys(attributes)) {
        const value = attributes[name].join(' ')
        if (name === 'style') {
          addStyleString(element.style, value)
        } else {
          element.setAttribute(name, value)
        }
      }
      return element
    }
    const getBlockedSelectors = async ( selectors ) => {
      const d = document
      const root = d.createElement('div')
      const elements = new Array(selectors.length)
      const blockedSelectors = {}
      forceShow(root)
      for (let i = 0; i < selectors.length; ++i) {
        const element = selectorToElement(selectors[i])
        if (element.tagName === 'DIALOG') {
          element.show()
        }
        const holder = d.createElement('div') // Protects from unwanted effects of `+` and `~` selectors of filters
        forceShow(holder)
        holder.appendChild(element)
        root.appendChild(holder)
        elements[i] = element
      }
      while (!d.body) {
        await new Promise(( r ) => setTimeout(r, 50));
      }
      d.body.appendChild(root)

      try {
        for (let i = 0; i < selectors.length; ++i) {
          if (!elements[i].offsetParent) {
            blockedSelectors[selectors[i]] = true
          }
        }
      } finally {
        root.parentNode?.removeChild(root)
      }
      return blockedSelectors
    }
    const filters = this.getFilters()
    const filterNames = Object.keys(filters)
    const allSelectors = [].concat(...filterNames.map(( filterName ) => filters[filterName]))
    const blockedSelectors = await getBlockedSelectors(allSelectors)
    if (debug) {
      printDebug(filters, blockedSelectors)
    }
    const activeBlockers = filterNames.filter(( filterName ) => {
      const selectors = filters[filterName]
      const blockedCount = this.countTruthy(selectors.map(( selector ) => blockedSelectors[selector]))
      return blockedCount > selectors.length * 0.6
    })
    activeBlockers.sort()
    return activeBlockers
  }

  /*异步 字体*/
  async getFonts() {
    const fontList = [
      // This is android-specific font from "Roboto" family
      'sans-serif-thin',
      'ARNO PRO',
      'Agency FB',
      'Arabic Typesetting',
      'Arial Unicode MS',
      'AvantGarde Bk BT',
      'BankGothic Md BT',
      'Batang',
      'Bitstream Vera Sans Mono',
      'Calibri',
      'Century',
      'Century Gothic',
      'Clarendon',
      'EUROSTILE',
      'Franklin Gothic',
      'Futura Bk BT',
      'Futura Md BT',
      'GOTHAM',
      'Gill Sans',
      'HELV',
      'Haettenschweiler',
      'Helvetica Neue',
      'Humanst521 BT',
      'Leelawadee',
      'Letter Gothic',
      'Levenim MT',
      'Lucida Bright',
      'Lucida Sans',
      'Menlo',
      'MS Mincho',
      'MS Outlook',
      'MS Reference Specialty',
      'MS UI Gothic',
      'MT Extra',
      'MYRIAD PRO',
      'Marlett',
      'Meiryo UI',
      'Microsoft Uighur',
      'Minion Pro',
      'Monotype Corsiva',
      'PMingLiU',
      'Pristina',
      'SCRIPTINA',
      'Segoe UI Light',
      'Serifa',
      'SimHei',
      'Small Fonts',
      'Staccato222 BT',
      'TRAJAN PRO',
      'Univers CE 55 Medium',
      'Vrinda',
      'ZWAdobeF',
    ]
    const baseFonts = ['monospace', 'sans-serif', 'serif'];
    const testString = 'mmMwWLliI0O&1';
    const textSize = '48px';
    return this.withIframe(async ( _, { document } ) => {
      const root = document.body;
      root.style.fontSize = textSize;
      const spansContainer = document.createElement('div')
      const fragment = document.createDocumentFragment()
      spansContainer.style.setProperty('visibility', 'hidden', 'important')
      const defaultWidth = {}
      const defaultHeight = {}
      const createSpan = ( fontFamily ) => {
        const span = document.createElement('span')
        span.style.position = 'absolute'
        span.style.top = '0'
        span.style.left = '0'
        span.style.fontFamily = fontFamily
        span.textContent = testString
        fragment.append(span)
        return span
      }
      const createSpanWithFonts = ( fontToDetect, baseFont ) => createSpan(`'${fontToDetect}',${baseFont}`)
      const initializeBaseFontsSpans = () => {
        return baseFonts.map(createSpan)
      }
      const initializeFontsSpans = () => {
        const spans = {}
        for (const font of fontList) {
          spans[font] = baseFonts.map(( baseFont ) => createSpanWithFonts(font, baseFont))
        }
        return spans
      }
      const isFontAvailable = ( fontSpans ) => {
        return baseFonts.some(
          ( baseFont, baseFontIndex ) =>
            fontSpans[baseFontIndex].offsetWidth !== defaultWidth[baseFont] ||
            fontSpans[baseFontIndex].offsetHeight !== defaultHeight[baseFont],
        )
      }

      const baseFontsSpans = initializeBaseFontsSpans()
      const fontsSpans = initializeFontsSpans()
      spansContainer.appendChild(fragment)
      root.appendChild(spansContainer)
      for (let index = 0; index < baseFonts.length; index++) {
        defaultWidth[baseFonts[index]] = baseFontsSpans[index].offsetWidth
        defaultHeight[baseFonts[index]] = baseFontsSpans[index].offsetHeight
      }
      return fontList.filter(( font ) => isFontAvailable(fontsSpans[font]))
    })
  }

  /*异步 字体偏好*/
  async getFontPreferences() {
    const withNaturalFonts = ( action, containerWidthPx = 4000, ) => {
      return this.withIframe(( _, iframeWindow ) => {
        const iframeDocument = iframeWindow.document
        const iframeBody = iframeDocument.body
        const bodyStyle = iframeBody.style
        bodyStyle.width = `${containerWidthPx}px`
        bodyStyle.webkitTextSizeAdjust = bodyStyle.textSizeAdjust = 'none'
        if (this.isChromium) {
          iframeBody.style.zoom = `${1 / iframeWindow.devicePixelRatio}`
        } else if (this.isWebKit) {
          iframeBody.style.zoom = 'reset'
        }
        const linesOfText = iframeDocument.createElement('div')
        linesOfText.textContent = [...Array((containerWidthPx / 20) << 0)].map(() => 'word').join(' ')
        iframeBody.appendChild(linesOfText)
        return action(iframeDocument, iframeBody)
      }, '<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1">')
    }
    const presets = {
      /**
       * The default font. User can change it in desktop Chrome, desktop Firefox, IE 11,
       * Android Chrome (but only when the size is ≥ than the default) and Android Firefox.
       */
      default: [],
      /** OS font on macOS. User can change its size and weight. Applies after Safari restart. */
      apple: [{ font: '-apple-system-body' }],
      /** User can change it in desktop Chrome and desktop Firefox. */
      serif: [{ fontFamily: 'serif' }],
      /** User can change it in desktop Chrome and desktop Firefox. */
      sans: [{ fontFamily: 'sans-serif' }],
      /** User can change it in desktop Chrome and desktop Firefox. */
      mono: [{ fontFamily: 'monospace' }],
      /**
       * Check the smallest allowed font size. User can change it in desktop Chrome, desktop Firefox and desktop Safari.
       * The height can be 0 in Chrome on a retina display.
       */
      min: [{ fontSize: '1px' }],
      /** Tells one OS from another in desktop Chrome. */
      system: [{ fontFamily: 'system-ui' }],
    }
    const defaultText = 'mmMwWLliI0fiflO&1'
    return withNaturalFonts(( document, container ) => {
      const elements = {}
      const sizes = {}
      for (const key of Object.keys(presets)) {
        const [style = {}, text = defaultText] = presets[key]
        const element = document.createElement('span')
        element.textContent = text
        element.style.whiteSpace = 'nowrap'

        for (const name of Object.keys(style)) {
          const value = style[name]
          if (value !== undefined) {
            element.style[name] = value
          }
        }
        elements[key] = element
        container.append(document.createElement('br'), element)
      }
      for (const key of Object.keys(presets)) {
        sizes[key] = elements[key].getBoundingClientRect().width
      }
      return sizes
    })
  }

  /*异步 屏幕可视区域（screen frame）的边距信息*/
  async getScreenFrame() {
    if (this.isWebKit && this.isWebKit616OrNewer && this.isSafariWebKit) {
      return () => Promise.resolve(undefined)
    }
    const screenFrameCheckInterval = 2500
    const d = document
    let screenFrameBackup
    let screenFrameSizeTimeoutId
    const getCurrentScreenFrame = () => {
      const s = screen
      const replaceNaN = ( value, replacement ) => typeof value === 'number' && isNaN(value) ? replacement : value
      return [
        replaceNaN(parseFloat(s.availTop), null),
        replaceNaN(parseFloat(s.width) - parseFloat(s.availWidth) - replaceNaN(parseFloat(s.availLeft), 0), null),
        replaceNaN(parseFloat(s.height) - parseFloat(s.availHeight) - replaceNaN(parseFloat(s.availTop), 0), null),
        replaceNaN(parseFloat(s.availLeft), null),
      ]
    }
    const isFrameSizeNull = ( frameSize ) => {
      for (let i = 0; i < 4; ++i) {
        if (frameSize[i]) {
          return false
        }
      }
      return true
    }
    const watchScreenFrame = () => {
      if (screenFrameSizeTimeoutId !== undefined) {
        return
      }
      const checkScreenFrame = () => {
        const frameSize = getCurrentScreenFrame()
        if (isFrameSizeNull(frameSize)) {
          screenFrameSizeTimeoutId = setTimeout(checkScreenFrame, screenFrameCheckInterval)
        } else {
          screenFrameBackup = frameSize
          screenFrameSizeTimeoutId = undefined
        }
      }
      checkScreenFrame()
    }
    const getUnstableScreenFrame = () => {
      watchScreenFrame()
      return async () => {
        let frameSize = getCurrentScreenFrame()
        if (isFrameSizeNull(frameSize)) {
          if (screenFrameBackup) {
            return [...screenFrameBackup]
          }
          if (this.getFullscreenElement()) {
            await this.exitFullscreen()
            frameSize = getCurrentScreenFrame()
          }
        }
        if (!isFrameSizeNull(frameSize)) {
          screenFrameBackup = frameSize
        }
        return frameSize
      }
    }
    const round = ( value, base = 1 ) => {
      if (Math.abs(base) >= 1) {
        return Math.round(value / base) * base
      } else {
        const counterBase = 1 / base
        return Math.round(value * counterBase) / counterBase
      }
    }
    const screenFrameGetter = getUnstableScreenFrame()
    return async () => {
      const frameSize = await screenFrameGetter()
      const processSize = sideSize => (sideSize === null ? null : round(sideSize, 10))
      return [processSize(frameSize[0]), processSize(frameSize[1]), processSize(frameSize[2]), processSize(frameSize[3])]
    }
  }

  /*获取音频指纹*/
  async getAudioFingerprint() {
    if ((this.isWebKit && this.isWebKit616OrNewer && this.isSafariWebKit) ||
      (this.isChromium && this.isSamsungInternet && this.isChromium122OrNewer)
    ) {
      return -4
    }
    const w = window
    const AudioContext = w.OfflineAudioContext || w.webkitOfflineAudioContext
    if (!AudioContext) {
      return -2
    }
    if (this.isWebKit && !this.isDesktopWebKit && !this.isWebKit606OrNewer) {
      return -1
    }

    const hashFromIndex = 4500
    const hashToIndex = 5000
    const context = new AudioContext(1, hashToIndex, 44100)

    const oscillator = context.createOscillator()
    oscillator.type = 'triangle'
    oscillator.frequency.value = 10000

    const compressor = context.createDynamicsCompressor()
    compressor.threshold.value = -50
    compressor.knee.value = 40
    compressor.ratio.value = 12
    compressor.attack.value = 0
    compressor.release.value = 0.25

    oscillator.connect(compressor)
    compressor.connect(context.destination)
    oscillator.start(0)
    const startRenderingAudio = ( context ) => {
      const renderTryMaxCount = 3
      const renderRetryDelay = 500
      const runningMaxAwaitTime = 500
      const runningSufficientTime = 5000
      let finalize = () => undefined
      const makeInnerError = ( name ) => {
        const error = new Error(name)
        error.name = name
        return error
      }

      const resultPromise = new Promise(( resolve, reject ) => {
        let isFinalized = false
        let renderTryCount = 0
        let startedRunningAt = 0
        context.oncomplete = ( event ) => resolve(event.renderedBuffer)
        const startRunningTimeout = () => {
          setTimeout(
            () => reject(makeInnerError('timeout')),
            Math.min(runningMaxAwaitTime, startedRunningAt + runningSufficientTime - Date.now()),
          )
        }
        const tryRender = () => {
          try {
            const renderingPromise = context.startRendering()
            if (!!renderingPromise && typeof renderingPromise.then === 'function') {
              suppressUnhandledRejectionWarning(renderingPromise)
            }
            switch (context.state) {
              case 'running':
                startedRunningAt = Date.now()
                if (isFinalized) {
                  startRunningTimeout()
                }
                break
              case 'suspended':
                if (!document.hidden) {
                  renderTryCount++
                }
                if (isFinalized && renderTryCount >= renderTryMaxCount) {
                  reject(makeInnerError('suspended'))
                } else {
                  setTimeout(tryRender, renderRetryDelay)
                }
                break
            }
          } catch (error) {
            reject(error)
          }
        }
        tryRender()
        finalize = () => {
          if (!isFinalized) {
            isFinalized = true
            if (startedRunningAt > 0) {
              startRunningTimeout()
            }
          }
        }
      })
      return [resultPromise, finalize]
    }
    const getHash = ( signal ) => {
      let hash = 0
      for (let i = 0; i < signal.length; ++i) {
        hash += Math.abs(signal[i])
      }
      return hash
    }
    const suppressUnhandledRejectionWarning = ( promise ) => {
      promise.then(undefined, () => undefined)
      return promise
    }
    const [renderPromise, finishRendering] = startRenderingAudio(context)
    const fingerprintPromise = suppressUnhandledRejectionWarning(
      renderPromise.then(
        ( buffer ) => getHash(buffer.getChannelData(0).subarray(hashFromIndex)),
        ( error ) => {
          if (error.name === 'timeout' || error.name === 'suspended') {
            return 'timeout'
          }
          throw error
        },
      ),
    )
    return () => {
      finishRendering()
      return fingerprintPromise
    }
  }

  /*webgl */
  getWebGLContext( cache = {} ) {
    if (cache.webgl) {
      return cache.webgl.context
    }
    const canvas = document.createElement('canvas')
    let context
    canvas.addEventListener('webglCreateContextError', () => (context = undefined))
    for (const type of ['webgl', 'experimental-webgl']) {
      try {
        context = canvas.getContext(type)
      } catch {
        console.log('')
      }
      if (context) {
        break
      }
    }

    cache.webgl = { context }
    return context
  }

  getWebGlBasics( cache = {} ) {
    const gl = this.getWebGLContext(cache)
    if (!gl) {
      return -1
    }
    if (typeof gl.getParameter !== 'function') {
      return -2
    }
    const debugExtension = this.isGecko ? null : gl.getExtension('WEBGL_debug_renderer_info')
    return {
      version: gl.getParameter(gl.VERSION)?.toString() || '',
      vendor: gl.getParameter(gl.VENDOR)?.toString() || '',
      vendorUnmasked: debugExtension ? gl.getParameter(debugExtension.UNMASKED_VENDOR_WEBGL)?.toString() : '',
      renderer: gl.getParameter(gl.RENDERER)?.toString() || '',
      rendererUnmasked: debugExtension ? gl.getParameter(debugExtension.UNMASKED_RENDERER_WEBGL)?.toString() : '',
      shadingLanguageVersion: gl.getParameter(gl.SHADING_LANGUAGE_VERSION)?.toString() || '',
    }
  }

  getWebGlExtensions( cache = {} ) {
    const gl = this.getWebGLContext(cache)
    if (!gl) {
      return -1
    }
    if (typeof gl.getParameter !== 'function') {
      return -2
    }
    const validContextParameters = new Set([
      10752, 2849, 2884, 2885, 2886, 2928, 2929, 2930, 2931, 2932, 2960, 2961, 2962, 2963, 2964, 2965, 2966, 2967, 2968,
      2978, 3024, 3042, 3088, 3089, 3106, 3107, 32773, 32777, 32777, 32823, 32824, 32936, 32937, 32938, 32939, 32968, 32969,
      32970, 32971, 3317, 33170, 3333, 3379, 3386, 33901, 33902, 34016, 34024, 34076, 3408, 3410, 3411, 3412, 3413, 3414,
      3415, 34467, 34816, 34817, 34818, 34819, 34877, 34921, 34930, 35660, 35661, 35724, 35738, 35739, 36003, 36004, 36005,
      36347, 36348, 36349, 37440, 37441, 37443, 7936, 7937, 7938,
    ])
    const validExtensionParams = new Set([
      34047, // MAX_TEXTURE_MAX_ANISOTROPY_EXT
      35723, // FRAGMENT_SHADER_DERIVATIVE_HINT_OES
      36063, // MAX_COLOR_ATTACHMENTS_WEBGL
      34852, // MAX_DRAW_BUFFERS_WEBGL
      34853, // DRAW_BUFFER0_WEBGL
      34854, // DRAW_BUFFER1_WEBGL
      34229, // VERTEX_ARRAY_BINDING_OES
      36392, // TIMESTAMP_EXT
      36795, // GPU_DISJOINT_EXT
      38449, // MAX_VIEWS_OVR
    ])
    const shaderTypes = ['FRAGMENT_SHADER', 'VERTEX_SHADER']
    const precisionTypes = ['LOW_FLOAT', 'MEDIUM_FLOAT', 'HIGH_FLOAT', 'LOW_INT', 'MEDIUM_INT', 'HIGH_INT']
    const isConstantLike = ( key ) => {
      return typeof key === 'string' && !key.match(/[^A-Z0-9_x]/)
    }
    const getConstantsFromPrototype = ( obj ) => {
      const keys = Object.keys(obj.__proto__)
      return keys.filter(isConstantLike)
    }
    const getShaderPrecision = ( gl, shaderType, precisionType ) => {
      const shaderPrecision = gl.getShaderPrecisionFormat(gl[shaderType], gl[precisionType])
      return shaderPrecision ? [shaderPrecision.rangeMin, shaderPrecision.rangeMax, shaderPrecision.precision] : []
    }
    const extensions = gl.getSupportedExtensions()
    const contextAttributes = gl.getContextAttributes()
    const unsupportedExtensions = []
    const attributes = []
    const parameters = []
    const extensionParameters = []
    const shaderPrecisions = []
    if (contextAttributes) {
      for (const attributeName of Object.keys(contextAttributes)) {
        attributes.push(`${attributeName}=${contextAttributes[attributeName]}`)
      }
    }
    const constants = getConstantsFromPrototype(gl)
    for (const constant of constants) {
      const code = gl[constant]
      parameters.push(`${constant}=${code}${validContextParameters.has(code) ? `=${gl.getParameter(code)}` : ''}`)
    }
    if (extensions) {
      for (const name of extensions) {
        if (
          (name === 'WEBGL_debug_renderer_info' && this.isGecko) ||
          (name === 'WEBGL_polygon_mode' && this.isGecko)
        ) {
          continue
        }

        const extension = gl.getExtension(name)
        if (!extension) {
          unsupportedExtensions.push(name)
          continue
        }
        for (const constant of getConstantsFromPrototype(extension)) {
          const code = extension[constant]
          extensionParameters.push(
            `${constant}=${code}${validExtensionParams.has(code) ? `=${gl.getParameter(code)}` : ''}`,
          )
        }
      }
    }
    for (const shaderType of shaderTypes) {
      for (const precisionType of precisionTypes) {
        const shaderPrecision = getShaderPrecision(gl, shaderType, precisionType)
        shaderPrecisions.push(`${shaderType}.${precisionType}=${shaderPrecision.join(',')}`)
      }
    }
    extensionParameters.sort()
    parameters.sort()
    return {
      contextAttributes: attributes,
      parameters: parameters,
      shaderPrecisions: shaderPrecisions,
      extensions: extensions,
      extensionParameters: extensionParameters,
      unsupportedExtensions,
    }
  }
}

window.BrowserUID = BrowserUID
